export default "__VITE_ASSET__D0M0lvGb__"